/** Quill only ships ql-indent-1 … ql-indent-8. */
export const MAX_QUILL_LIST_INDENT = 8;
